import {
  parse as parseDate,
  isValid as isValidDate,
  endOfMonth,
} from 'date-fns'

import parseWeekdays from './parseWeekdays'

import {
  segmentSeparator as SCHEDULE_SEGMENT_SEPARATOR,
  scheduleSeparator as SCHEDULE_SEPARATOR,
  weekdaysPrefix as SCHEDULE_WEEKDAYS_PREFIX,
} from './constants/format.json'

const parseStartDate = maybeDateStr => {
  if (maybeDateStr === null) {
    return null
  }
  const tryParsedDate = parseDate(maybeDateStr)
  if (!isValidDate(tryParsedDate)) {
    return null
  }
  return tryParsedDate
}

const parseEndDate = (maybeEndDateStr, refStartDateStr = null) => {
  if (refStartDateStr !== null) {
    const [
      refStartDateYear,
      refStartDateMonth = null,
      refStartDateDate = null,
    ] = refStartDateStr.split('-')

    if (maybeEndDateStr === null) {
      if (refStartDateMonth === null) {
        return null
      }

      const startDate = parseStartDate(refStartDateStr)

      if (refStartDateDate === null) {
        return endOfMonth(startDate)
      }

      return startDate
    }

    const refEndDateFragments = maybeEndDateStr.split('-')

    if (refEndDateFragments.length === 3) {
      return parseDate(maybeEndDateStr)
    }

    if (refEndDateFragments.length === 2) {
      if (refStartDateDate === null) {
        return endOfMonth(
          parseDate(`${refEndDateFragments[0]}-${refEndDateFragments[1]}`),
        )
      }
      return parseDate(
        `${refStartDateYear}-${refEndDateFragments[0]}-${refEndDateFragments[1]}`,
      )
    }

    if (refEndDateFragments.length === 1) {
      if (refStartDateDate === null) {
        return endOfMonth(
          parseDate(`${refStartDateYear}-${refEndDateFragments[0]}`),
        )
      }
      return parseDate(
        `${refStartDateYear}-${refStartDateMonth}-${refEndDateFragments[0]}`,
      )
    }
  }

  if (maybeEndDateStr === null) {
    return parseStartDate(refStartDateStr)
  }

  return null
}

const parseSingleSchedule = maybeSchedule => {
  let theMaybeSchedule = maybeSchedule.trim()

  if (!theMaybeSchedule.startsWith(SCHEDULE_WEEKDAYS_PREFIX)) {
    theMaybeSchedule = `${SCHEDULE_SEGMENT_SEPARATOR}${theMaybeSchedule}`
  }

  const [rawWeekdays, rawStart = null, rawEnd = null] = theMaybeSchedule.split(
    SCHEDULE_SEGMENT_SEPARATOR,
  )

  if (rawStart === null) {
    // invalid schedule
    return null
  }

  return {
    weekdays: parseWeekdays(rawWeekdays),
    start: parseStartDate(rawStart),
    end: parseEndDate(rawEnd, rawStart),
  }
}

const parseSchedule = scheduleGroupStr => {
  if (typeof scheduleGroupStr !== 'string') {
    return null
  }

  return scheduleGroupStr
    .split(SCHEDULE_SEPARATOR)
    .filter(scheduleStr => scheduleStr.length > 0)
    .map(parseSingleSchedule)
}

export default parseSchedule
